export default __webpack_public_path__ + "static/media/Ar.dd62d225.svg";